import React from 'react';
import { Box } from '@hover/blueprint';
import PremiumFeatures from './PremiumFeatures';

const PremiumFeatureTabletAndDesktop: React.FC = () => (
  <Box d={{ base: 'none', tablet: 'flex' }} flexDir="column">
    <PremiumFeatures />
  </Box>
);

export default PremiumFeatureTabletAndDesktop;
